(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/transaction-history-error-row.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/transaction-history-error-row.js');

'use strict';

const {
  TableRow,
  TableCell
} = svs.ui.reactTable;
const TransactionHistoryErrorRow = () => React.createElement(TableRow, null, React.createElement(TableCell, {
  className: "transaction-history-table-column",
  colspan: "3"
}, "Det gick inte att h\xE4mta din kontohistorik f\xF6r vald m\xE5nad. F\xF6rs\xF6k igen senare."));
svs.arena.pages.teams.components.TransactionHistoryErrorRow = TransactionHistoryErrorRow;

 })(window);